// api-error.ts

import { BaseError, ApiErrorCode } from "./api-error-types";

export class ApiError extends Error implements BaseError {
  public readonly type = 'ApiError' as const;
  constructor(
    public readonly code: ApiErrorCode,
    message: string,
    public readonly details?: any
  ) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
  }

  toJSON() {
    return {
      type: this.type,
      code: this.code,
      message: this.message,
      details: this.details,
    };
  }
}
